import {
  ENDPOINT_ROOT,
  ENDPOINT_UPDATE_COOKIE_ACCEPTANCE,
  ENDPOINT_USERS_CURRENT,
} from '@/common/constants';
import axiosAuth from '@/common/interceptors/axios.AuthInterceptor';

const putCookie = ({ isCookieAcceptance }) => {
  const params = {
    cookie_acceptance: isCookieAcceptance,
  };

  return axiosAuth
    .put(
      `${ENDPOINT_ROOT}/${ENDPOINT_USERS_CURRENT}/${ENDPOINT_UPDATE_COOKIE_ACCEPTANCE}`,
      params,
    )
    .then((res) => res.data);
};

export default putCookie;
